import { node, icon, text } from "~/util/dom";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import createSDSIcon from "~/ui/icon";
import { CLOSE_24 } from "@sznds/icons";
import { BATTERY_100_24, BATTERY_10_24, BATTERY_30_24, BATTERY_5_24, BATTERY_65_24, BATTERY_85_24, FINNISH_16 } from "~/util/sds-compatible-icons";
import { timePosition } from "~/util/format";
import { criterionToTypeIcon } from "~/util/route";
import { STALE_TIMEOUT } from "~/share-position2/utils";

// eslint-disable-next-line id-length
export function createSubscriptionTextInfo(subscription: ISubscriptionWithDescription, lang: string, _: (keyInput: string, ...rest: any[]) => string): HTMLDivElement {
	const output = node("div", { className: "ui-sp-subscriptionText" });
	const name = node("h2", {}, subscription.sharingType === "device" ? subscription.deviceName : subscription.user.name);
	const positionDate = new Date(subscription.positionTime);

	output.appendChild(name);

	// aktivni sdileni, nebo neukoncene sdileni pri navigaci
	if (subscription.sharingStatus === "active" || (subscription.sharingStatus === "expired" && subscription.sharingType === "navigation")) {
		// jde o sdileni pri navigaci
		if (subscription.sharingType === "navigation" || subscription.routeInfo) {
			const title = subscription.routeParts?.length
				? subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.titleVars?.titleMain || subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.title
				: "";
			const arrivalDate = new Date(subscription.routeInfo?.arrivalTime);

			// uzivatel jel a urcite dojel (podle appky)
			if (subscription.routeInfo?.destinationReached) {
				const para = node("p");
				const strong = node("strong");

				strong.appendChild(createSDSIcon({ symbol: FINNISH_16, className: "icon" }));
				strong.appendChild(text(`${_("sharePosition.textExpired")}`));
				para.appendChild(strong);
				para.appendChild(text(` (${subscription.positionTime ? timePosition(positionDate).toLocaleLowerCase() : ""}) ${_("sharePosition.to")} ${title}`));

				output.appendChild(para);
				output.classList.add("ui-sp-subscription-text--expired");
			// expirovalo znamena, ze si myslime, ze dojel do cile, ale nevime to jiste, nebo predpokladany cas prijezdu uz nastal, ale nemame info o tom, ze uzivatel dorazil
			} else if (subscription.sharingStatus === "expired" || new Date().getTime() > arrivalDate.getTime()) {
				const para = node("p");
				const strong = node("strong");

				strong.appendChild(createSDSIcon({ symbol: FINNISH_16, className: "icon" }));
				strong.appendChild(text(`${_("sharePosition.estimatedArrival")} ${timePosition(arrivalDate).toLocaleLowerCase()}`));
				para.appendChild(strong);
				output.appendChild(para);
				output.appendChild(node("p", {}, `${_("sharePosition.to")} ${title}`));
			// uzivatel stale jede
			} else if (subscription.sharingStatus === "active") {
				const criterionIcon = subscription.routeParts?.length ? icon(criterionToTypeIcon(subscription.routeParts[subscription.routeInfo?.routeIndex].routeSettings.criterion)) : text("");
				const enroute = node("p");
				const highlight = node("em");

				highlight.appendChild(criterionIcon);
				highlight.appendChild(text(`${_("sharePosition.enRoute2")}`));
				enroute.appendChild(highlight);
				enroute.appendChild(text(` ${_("sharePosition.to")} ${title}`));
				output.appendChild(enroute);

				// mame cerstva data
				if (!isNaN(arrivalDate.getTime())) {
					if (positionDate.getTime() + STALE_TIMEOUT >= new Date().getTime()) {
						output.appendChild(node("p", {}, `${_("sharePosition.arrival")} ${timePosition(arrivalDate).toLocaleLowerCase()} (${new Intl.DateTimeFormat(lang, { hour: "numeric", minute: "numeric" }).format(arrivalDate)})`));
					// informace je zastarala
					} else {
						output.appendChild(node("p", {}, `${_("sharePosition.estimatedArrival")} ${timePosition(arrivalDate).toLocaleLowerCase()} (${new Intl.DateTimeFormat(lang, { hour: "numeric", minute: "numeric" }).format(arrivalDate)})`));
					}
				}
			}
		// obecne sdileni polohy
		} else if (subscription.sharingType === "generic" || subscription.sharingType === "device") {
			subscription.position && subscription.whereami && output.appendChild(node("p", {}, subscription.whereami.title));
		}

		// radek se stavem baterie a casem aktualizace
		const statusLine = node("div", { className: "ui-sp-subscriptionText__statusLine" });

		// stav baterie u starych sdileni neni
		if ("battery" in subscription.deviceInfo) {
			const battery = subscription.deviceInfo.battery;
			const batteryInfo = node("p", { className: "ui-sp-subscriptionText__battery" });

			switch (true) {
				case battery <= 5:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_5_24 }));
					batteryInfo.classList.add("ui-sp-subscriptionText__battery--low");
					break;

				case battery <= 10:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_10_24 }));
					batteryInfo.classList.add("ui-sp-subscriptionText__battery--low");
					break;

				case battery <= 30:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_30_24 }));
					break;

				case battery <= 65:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_65_24 }));
					break;

				case battery <= 85:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_85_24 }));
					break;

				case battery <= 100:
					batteryInfo.appendChild(createSDSIcon({ symbol: BATTERY_100_24 }));
					break;

				default:
					//
			}

			batteryInfo.appendChild(text(`${battery}%`));
			statusLine.appendChild(batteryInfo);
		}

		// cas aktualizace
		subscription.positionTime && statusLine.appendChild(node("p", {}, `${_("sharePosition.textUpdated")} ${timePosition(positionDate).toLocaleLowerCase()}`));

		output.appendChild(statusLine);
	// uz je to skoncene
	} else {
		const para = node("p", { className: "ui-sp-subscriptionText__canceled" });

		para.appendChild(createSDSIcon({ symbol: CLOSE_24 }));
		para.appendChild(node("span", {}, `${_("sharePosition.textCanceled")} ${subscription.positionTime ? timePosition(positionDate).toLocaleLowerCase() : ""}`));

		output.appendChild(para);
	}

	return output;
}
